import { Icon as PhosphorIcon } from '@phosphor-icons/react'

import { Icon } from '@/components/ui/icon'

import * as S from './section-header.styled'

interface SectionHeaderProps {
  icon?: PhosphorIcon
  title: string
  description: string
}

export const SectionHeader = ({ icon, description, title }: SectionHeaderProps) => {
  return (
    <S.SectionHeader>
      {icon && (
        <S.IconContainer>
          <Icon icon={icon} size="2.4rem" />
        </S.IconContainer>
      )}
      <S.Content>
        <S.Title>{title}</S.Title>
        <S.Description>{description}</S.Description>
      </S.Content>
    </S.SectionHeader>
  )
}
